import { createAsyncThunk } from "@reduxjs/toolkit";
import * as ProjectServiceApi from "apis/ProjectServiceApi";
import { ProjectDetails } from "types";
import { setProcessedData, setProjectDetails } from "./projectDetails.slice";
import { getDaysLeft } from "./projectDetails.helpers";
import { Item } from "components/popup/BenevvPopupEvents/BenevvPopupEvent";

export const fetchProjectById = createAsyncThunk(
  "projects/projectDetails/fetchById",
  async (project_id: ProjectDetails["id"], thunkAPI) => {
    try {
      const response = await ProjectServiceApi.getProjectByID({ project_id });
      thunkAPI.dispatch(setProjectDetails(response))

      const campaigns = response.campaigns || [];
      const fundCardData = campaigns.map((c: any) => ({
        name: c.name,
        fundraiserId: c.short_id,
        daysLeft: getDaysLeft(c.end_date_time),
        totalAmounts: c.goal,
        currentAmounts: c.total_raised ?? 0,
        totalDonors: c.count_donor ?? 0,
        user_id: c.user_id,
      }));

      const now = new Date();
      const upcomingEvents = (
        response.activities
      )?.filter((ev: Item) => new Date(ev.start_date_time) >= now) || [];
      const pastEvents = (
        response.activities
      )?.filter((ev: Item) => new Date(ev.start_date_time) < now) || [];

      const posts = (
        response.posts
      )?.map((p: any) => ({
        id: p.id,
        post_caption: p.post_caption,
        images: p.images || [],
      })) || [];

      thunkAPI.dispatch(setProcessedData({
        fundraisingData: fundCardData,
        upcomingEvents,
        pastEvents,
        posts,
      }));
    } catch (error) {
      if (error instanceof Error) {
        thunkAPI.rejectWithValue(error.message);
      }
      thunkAPI.rejectWithValue("Error fetching projects");
    }
  }
);

